import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  pt: 1,
};

export const noDataTitleBox: SxStyle = {
  position: 'relative',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  height: (p) => p.spacing(10),
};

export const noDataTitle: SxStyle = {
  color: (p) => p.palette.grey[500],
  fontSize: (p) => p.typography.body2,
};
